/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Order_Lot_Trace_EmptyInputs */

const vi_order_lot_trace_empty = /** @type {(inputs: Order_Lot_Trace_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đơn chưa có lô sản phẩm để truy xuất`)
};

/**

* @param {Order_Lot_Trace_EmptyInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const order_lot_trace_empty = /** @type {((inputs?: Order_Lot_Trace_EmptyInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Order_Lot_Trace_EmptyInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_order_lot_trace_empty(inputs)
});